import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { Grid, Typography, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import { PlanSubscriptionPrice } from '../Prices';
import CustomSwitch from '../CustomSwitch';
import { PERIODICITY } from '../../actions/products';


/**
 * Form to update or create a subscription
 * Used in ChangeSubscription and CreateSubscription
 * Displays number of licence input, total price for subscription
 * and optionnally a plan select
 */

const styles = theme => ({
  subtotal: {
    marginTop: 24,
  },
  captionColor: {
    color: '#797979'
  },
  inputRoot: {
    fontSize: 16,
    height: 36,
    width: 72,
  },
  textSize:{
    fontSize: 12,
  },
  focused: {
  },
  unFocused: {
    color: grey[500],
  },
  dialogIcon: {
    marginRight: 12,
    verticalAlign: 'middle',   
  },
  dialogSecondaryText: {
      marginTop: 16,
  }
})

class SubscriptionForm extends Component {
  

  /**
   * Called when the licences count has changed
   * @param {Event} e 
   */
  handleChangeLicencesCount(e) {
    const { handleLicencesCount } = this.props;
    if (handleLicencesCount) {
      const licencesCount = parseInt(e.target.value, 10);
      handleLicencesCount(licencesCount);
    }
  }

  render() {
    const {
      plan,
      licencesCount,
      handleLicencesCount,
      classes,
      isBothPeriodicityAvailable,
      switchOnMonthlySubscriptionPlan,
      handleSwitchOnPeriod,
      targetPlan
    } = this.props;

    return (
      <Grid container spacing={24}>
        {handleLicencesCount && (
          <Grid item sm>
            <Typography variant="caption" className={classes.captionColor}>
              <FormattedMessage id='subscription.form.licencesCount.label' />
            </Typography>
            <TextField
              InputProps={{ classes: { root: classes.inputRoot } }}
              fullWidth
              margin="normal"
              type="number"
              variant="outlined"
              
              // check isNaN to handle empty strings 
              value={isNaN(licencesCount) ? '' : licencesCount}
              onChange={e => this.handleChangeLicencesCount(e)}
              helperText={
                plan.licencesCount > 1
                  ? <FormattedMessage
                    id='subscription.form.licencesCount.helper'
                    values={{
                      licencesCount: plan.licencesCount
                    }}
                  />
                  : ""
              }
            />
          </Grid>
        )}
        <Grid item sm>
          <Typography variant="caption" className={classes.captionColor}>
            <FormattedMessage id='subscription.form.subtotal.label' />
          </Typography>
          <Typography className={classes.subtotal}>
            <PlanSubscriptionPrice
              plan={targetPlan}
              licencesCount={licencesCount}
            />
          </Typography>
          {(isBothPeriodicityAvailable) &&
            <div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}} >
              <Typography 
                variant="button" 
                className={switchOnMonthlySubscriptionPlan ? classNames(classes.focus, classes.textSize) : classNames(classes.unFocused, classes.textSize)}>
                <FormattedMessage id='product.switcher.monthly.text'/>
              </Typography>
                <CustomSwitch
                  checked={!switchOnMonthlySubscriptionPlan}
                  onChange={switchOnMonthlySubscriptionPlan ? () => handleSwitchOnPeriod(PERIODICITY.YEARLY) : () => handleSwitchOnPeriod(PERIODICITY.MONTHLY)} 
                  value="MonthlyYearlySwitcher"
                  inputProps={{ 'aria-label': 'MonthlyYearlySwitcher' }}
                />
              <Typography 
                variant="button" 
                className={switchOnMonthlySubscriptionPlan ? classNames(classes.unFocused, classes.textSize) : classNames(classes.focus, classes.textSize)}> 
                <FormattedMessage id='product.switcher.yearly.text'/>
              </Typography>
            </div>
          }
        </Grid>
      </Grid>
    );
  }
}

SubscriptionForm.propTypes = {
  classes: PropTypes.object.isRequired,
  plans: PropTypes.array,
  plan: PropTypes.object.isRequired,
  licencesCount: PropTypes.number,
  handleLicencesCount: PropTypes.func
}

export default withStyles(styles)(
  SubscriptionForm
);


// WEBPACK FOOTER //
// ./src/components/subscriptions/SubscriptionForm.js